"use client"

import { useProfileQuery } from "@/features/auth/api/profile-queries"
import { StreamStatsContent } from "@/features/stream-stats"
import { PageTracking } from "@/hooks/usePageTracking"
import { useIsMobile } from "@/hooks/use-mobile"
import { AuthenticatedPageLayout } from "@/layouts/authenticated-page"
import { CenteredPageLoader, ScrollArea } from "@/shared/ui"

import classes from "./page.module.scss"
import { ADMIN_ROUTES } from "@/config/admin-routes"

export default function Page() {
  PageTracking.useStreamStats()
  const isMobile = useIsMobile()
  const { data: profile, isLoading: isProfileLoading } = useProfileQuery()

  return (
    <AuthenticatedPageLayout
      lockHeight
      className={classes.streamStatsPageContent}
      allowedRoles={["STREAMER"]}
      redirectTo={ADMIN_ROUTES.streamers}
    >
      {isProfileLoading ? (
        <CenteredPageLoader />
      ) : (
        <ScrollArea
          className={classes.scrollArea}
          classNames={{ content: classes.scrollAreaContent }}
          fillViewport={isMobile}
          safeAreaBottom
        >
          <StreamStatsContent profile={profile} />
        </ScrollArea>
      )}
    </AuthenticatedPageLayout>
  )
}
